(function() {

    angular
        .module('app')
        .directive('modalMovable', ['$document',
    		function($document) {
    		    return {
    		        restrict: 'AC',
    		        link: function(scope, iElement, iAttrs) {
    		            var startX = 0,
    		                startY = 0,
    		                x = Math.max(0, (($(window).width() - $('.ruta').outerWidth()) / 2) + $(window).scrollLeft()),
    		                y = Math.max(0, (($(window).height() - $('.ruta').outerHeight()) / 2) + $(window).scrollTop());
		
    		            var dialogWrapper = iElement.parent();

						
    		            dialogWrapper.css({
    		            	zIndex:980,
    		                position: 'absolute',
    		                top:Math.max(0, (($(window).height() - $('.ruta').outerHeight()) / 2) + $(window).scrollTop()),
    		                left:Math.max(0, (($(window).width() - $('.ruta').outerWidth()) / 2) + $(window).scrollLeft())
    		            });
		
    		            iElement.find('.modal__header').on('mousedown', function(event) {
    		                // Prevent default dragging of selected content
    		                event.preventDefault();
    		                startX = event.pageX - x;
    		                startY = event.pageY - y;
    		                $document.on('mousemove', mousemove);
    		                $document.on('mouseup', mouseup);
    		            });
		
    		            function mousemove(event) {
    		                y = event.pageY - startY;
    		                x = event.pageX - startX;
    		                dialogWrapper.css({
    		                    top: y + 'px',
    		                    left: x + 'px'
    		                });
    		            }
		
    		            function mouseup() {
    		                $document.unbind('mousemove', mousemove);
    		                $document.unbind('mouseup', mouseup);
    		            }
    		        }
    		    };
    		}
		]);
})();
